/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CalendarOutlined,
  CaretDownOutlined,
  DollarOutlined,
  IdcardOutlined,
  SyncOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { DateField, List, useModalForm, useTable } from '@refinedev/antd'
import {
  BaseRecord,
  CrudFilters,
  getDefaultFilter,
  IResourceComponentsProps,
  useGetIdentity,
} from '@refinedev/core'
import { Badge, notification, Table } from 'antd'
import { ColumnType } from 'antd/es/table'
import { TableRowSelection } from 'antd/es/table/interface'
import dayjs from 'dayjs'
import { FC, Key, useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGetListCryptoWithdrawal } from '../../api/wallet'
import { BulkApproveButton } from '../../components/pages/payment-request/bulk-approve-btn'
import { IIdentity } from '../../components/providers/authProvider'
import { cornerBadgeOnCell, NewTag } from '../components/newTag'
import PaymentStatus from '../../types/paymentStatus.type'
import { ModalType } from '../../types/ui'
import {
  errorNotification,
  paymentRequestEditQueryOptions,
} from '../../utils/edit.constants'
import { useIsAdminRole } from '../../utils/hooks/useIdentityAdmin.hook'
import { usePaymentRequestBulkApprove } from '../../utils/hooks/usePaymentRequestBulkApprove.hook'
import { usePrevious } from '../../utils/hooks/usePrevious'
import {
  useWorldCheckVerification,
  VerificationStatus,
} from '../../utils/hooks/useWorldCheckVerification.hook'
import { disableCheckbox } from '../../utils/listColumnUtils'
import {
  paymentStatusColors,
  paymentStatusNames,
} from '../../utils/paymentStatus.utils'
import { formatDate } from '../components/constants'
import { PaymentRequestsEditForm, Row } from '../components/interface'
import '../invoicePayables/InvoicePayablesList'
import '../styles/index.css'
import { PaymentRequestEdit } from './edit'
import { StatusFilter } from './StatusFilter'
import { TableForm } from './tableForm'

const ADMIN_COLUMN_KEYS = ['customer.fullName']

const TRANSFER_MODE = {
  SMART_USER: 'SMART UID',
  SEND_VIA_CRYPTO_NETWORK: 'Crypto Network',
}

interface ISendMoneySearchProps {
  searchValue: string
  createdAt?: Date[] | null
  status: PaymentStatus
}

const start = 0
const end = 10

export const CryptoWithdrawalList: FC<IResourceComponentsProps> = () => {
  const { data: identity } = useGetIdentity<IIdentity>()
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const current = queryParams.get('current')
  const pageSize = queryParams.get('pageSize')
  const [editingId, setEditingId] = useState<number>()
  const prevEditingId = usePrevious(editingId)
  const [selectedIds, setSelectedIds] = useState<Key[]>([])
  const isAdminRole = useIsAdminRole()
  const [newViewedIds, setNewViewedIds] = useState<number[]>([])
  const { bulkApprove } = usePaymentRequestBulkApprove()
  const [api, alertContextHolder] = notification.useNotification()
  const [searchStatus, setSearchStatus] = useState<any>()
  const [searchName, setSearchName] = useState<any>()
  const [searchDate, setSearchDate] = useState<any>()
  const {
    close: editModalClose,
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editModalShow,
    formLoading: editFormLoading,
    id: modalEditingId,
    setId: setModalEditingId,
    queryResult: editQueryResult,
  } = useModalForm<PaymentRequestsEditForm>({
    action: 'edit',
    onMutationSuccess: () => {
      editModalClose()
      setModalType('none')
      resetEditingId()
    },
    id: editingId,
    errorNotification,
    queryOptions: {
      ...paymentRequestEditQueryOptions,
      enabled: false,
      cacheTime: 0,
    },
  })

  const {
    tableProps,
    searchFormProps,
    filters,
    tableQueryResult: { refetch: refetchList },
  } = useTable<Row>({
    syncWithLocation: true,
    pagination: {
      pageSize: 10,
    },
    onSearch: (data: unknown) => {
      const params = data as ISendMoneySearchProps
      const filters: CrudFilters = []
      const { searchValue, createdAt, status } = params
      setSearchStatus(PaymentStatus[status] ? status : undefined)
      setSearchName(searchValue)
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
      setSearchDate(
        createdAt && createdAt.length === 2
          ? {
            gte: dayjs(createdAt[0])
              .startOf('day')
              .toISOString(),
            lte: dayjs(createdAt[1])
              .endOf('day')
              .toISOString(),
            _timeZone: tz,
          }
          : undefined
      )
      setParams({
        start,
        end,
      })
      setCurrentPage(1)
      return filters
    },
  })

  const [currentPage, setCurrentPage] = useState(current ? Number(current) : 1)
  const [params, setParams] = useState({
    start: current ? (Number(current) - 1) * Number(pageSize) : start,
    end: pageSize ? Number(current) * Number(pageSize) : end,
  })

  const {
    data = {
      data: {
        data: { items: [], total: 0, totalPages: 0, pageSize: 0, page: 0 },
      },
    },
    refetch: refetchWithdrawal,
  } = useGetListCryptoWithdrawal({
    ...params,
    status: searchStatus,
    name: searchName,
    gte: searchDate?.gte,
    lte: searchDate?.lte,
    timeZone: searchDate?._timeZone,
  })

  const prevModalEditingId = usePrevious(modalEditingId)

  const resetEditingId = useCallback(() => setEditingId(undefined), [])

  useEffect(() => {
    if (modalEditingId !== prevModalEditingId && modalEditingId !== undefined) {
      // editQueryResult?.refetch();
      editModalShow(editingId)
    }
  }, [
    modalEditingId,
    editModalShow,
    editQueryResult,
    editingId,
    prevModalEditingId,
  ])

  useEffect(() => {
    if (editingId !== prevEditingId && editingId !== undefined) {
      setModalEditingId(editingId)
    }
  }, [editingId, prevEditingId, setModalEditingId])

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setParams({
      start: (page - 1) * data?.data?.data?.pageSize || start,
      end: page * data?.data?.data?.pageSize || end,
    })
  }

  useEffect(() => {
    setNewViewedIds([])
  }, [tableProps.dataSource])

  const createdAt = useMemo(() => {
    const start = getDefaultFilter('', filters, 'gte')
    const end = getDefaultFilter('', filters, 'lte')
    const startFrom = dayjs(start)
    const endAt = dayjs(end)

    if (start && end) {
      return [startFrom, endAt]
    }
    return undefined
  }, [filters])
  const [modalType, setModalType] = useState<ModalType>('none')

  const { data: worldCheckVerification } = useWorldCheckVerification()

  const handleClickOnCell = useCallback(
    (record: BaseRecord) => {
      return {
        onClick: () => {
          if (
            [
              VerificationStatus.PENDING,
              VerificationStatus.REQUIRED,
              VerificationStatus.HIGH_RISK_FIR,
            ].some((status) => status === worldCheckVerification?.status) &&
            !isAdminRole
          ) {
            setModalType('worldCheck')
          } else {
            const id = Number(record.id)
            if (id) {
              setModalType('edit')
              setEditingId(id)
              if (record['rowNotViewed']) {
                setNewViewedIds((newViewedIds) => [...newViewedIds, id])
              }
            }
          }
        },
      }
    },
    [worldCheckVerification?.status, isAdminRole]
  )

  const statusFilterValue = useMemo<PaymentStatus | undefined>(
    () => getDefaultFilter('_status', filters),
    [filters]
  )

  const showBulkApproveError = () => {
    api['error']({
      message: 'Bulk approve error',
      description:
        'One or several Send Money requests have empty Service Provider field. Fill out Service Provider to bulk approve selected items',
    })
  }

  const handleBulkApprove = async (): Promise<void> => {
    for (const row of tableProps.dataSource ?? []) {
      if (
        selectedIds.some((id) => id === row.id) &&
        row.serviceProviderId === null
      ) {
        showBulkApproveError()
        return
      }
    }

    await bulkApprove(selectedIds)
    setSelectedIds([])
    await refetchList()
  }

  const rowSelection = useMemo<TableRowSelection<Row>>(
    () => ({
      type: 'checkbox',
      selectedRowKeys: selectedIds,
      onChange: (selectedRowKeys) => {
        setSelectedIds(selectedRowKeys.slice(0, 5))
      },
      getCheckboxProps: disableCheckbox(selectedIds),
    }),
    [selectedIds]
  )

  const columns = useMemo((): ColumnType<Row>[] => {
    const columns: ColumnType<Row>[] = [
      {
        dataIndex: 'id',
        title: (
          <span className={'column-header'}>
            <IdcardOutlined />
            &nbsp;No.
          </span>
        ),
        onCell: handleClickOnCell,
      },
      {
        dataIndex: ['senderUser', 'fullName'],
        title: isAdminRole && (
          <span className={'column-header'}>
            <UserOutlined />
            &nbsp;Customer
          </span>
        ),
        onCell: handleClickOnCell,
        render: (_value: string, record: BaseRecord) => (
          <span style={{ color: 'black' }}>{_value || record?.senderUser?.email}</span>
        ),
        key: 'customer.fullName',
      },

      {
        dataIndex: 'status',
        title: (
          <span className={'column-header'}>
            <SyncOutlined />
            &nbsp;Status
          </span>
        ),
        onCell: handleClickOnCell,
        render: (value: string) => (
          <Badge
            color={paymentStatusColors[value]}
            text={paymentStatusNames[value]}
          />
        ),
      },
      {
        dataIndex: 'amount',
        title: (
          <span className={'column-header'}>
            <DollarOutlined />
            &nbsp;Amount
          </span>
        ),
        render: (value) => {
          return value
        },
        onCell: handleClickOnCell,
      },
      {
        dataIndex: 'currencyCode',
        title: (
          <span className={'column-header'}>
            <DollarOutlined />
            &nbsp;Currency
          </span>
        ),
        render: (_value: string, record: BaseRecord) => (
          <span>{record?.currency?.symbol}</span>
        ),
        onCell: handleClickOnCell,
      },
      {
        dataIndex: 'withdrawMethod',
        title: (
          <span className={'column-header'}>
            <CaretDownOutlined />
            &nbsp;Withdraw Method
          </span>
        ),
        render: (value: keyof typeof TRANSFER_MODE) => (
          <span>{TRANSFER_MODE[value]}</span>
        ),
        onCell: handleClickOnCell,
      },
      {
        dataIndex: 'withdrawAddress',
        title: (
          <span className={'column-header'}>
            <UserOutlined />
            &nbsp;Beneficiary
          </span>
        ),
        onCell: handleClickOnCell,
        render: (value: string | null, record: any) =>
          value ? (
            <span>{value}</span>
          ) : record?.smartUID ? (
            <span>{record?.smartUID}</span>
          ) : (
            <span style={{ color: 'red' }}>
              {record?.recipientEmail || 'N/A'}
            </span>
          ),
      },
      {
        dataIndex: 'createdAt',
        title: (
          <span className={'column-header'}>
            <CalendarOutlined />
            &nbsp;Created
          </span>
        ),
        onCell: cornerBadgeOnCell(handleClickOnCell),
        render: (value: string, record) => (
          <>
            <DateField value={value} format={formatDate} />
            {record['rowNotViewed'] && !newViewedIds.includes(record.id as number) && <NewTag />}
          </>
        ),
      },
    ]
    return columns.filter(
      ({ key }) => isAdminRole || !key || !ADMIN_COLUMN_KEYS.includes(`${key}`)
    )
  }, [handleClickOnCell, identity?.role, isAdminRole, newViewedIds])

  return (
    <>
      <List title='Crypto Withdrawal'>
        <TableForm
          {...searchFormProps}
          initialValues={{
            searchValue: getDefaultFilter('', filters),
            createdAt,
          }}
          onSubmit={searchFormProps.form?.submit}
        />
        <StatusFilter
          {...searchFormProps}
          defaultValue={statusFilterValue}
          isRequestStatusName={true}
        />
        <Table
          {...tableProps}
          rowKey='id'
          columns={columns as any}
          dataSource={data?.data?.data?.items}
          rowSelection={rowSelection as any}
          rowClassName={(record) =>
            isAdminRole &&
              record['rowNotViewed'] &&
              !newViewedIds.includes(record.id as number)
              ? 'ant-table-highlighted-row'
              : ''
          }
          pagination={{
            current: currentPage,
            total: data.data.data.total,
            pageSize: data.data.data.pageSize,
            onChange: handlePageChange,
          }}
        />
        <BulkApproveButton
          show={!!tableProps.dataSource?.length}
          onClick={handleBulkApprove}
          disabled={!selectedIds.length}
        />
      </List>
      {alertContextHolder}
      {modalType === 'edit' && (
        <PaymentRequestEdit
          modalProps={editModalProps}
          formProps={editFormProps}
          queryResult={editQueryResult}
          id={modalEditingId}
          formIsLoading={editFormLoading}
          close={() => {
            editModalClose()
            refetchWithdrawal()
          }}
          resetEditingId={resetEditingId}
          refetchWithdrawal={refetchWithdrawal}
        />
      )}
    </>
  )
}
